var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.$route.meta.isProductCase)?_c('Header'):_vm._e(),_c('div',{class:[_vm.$route.meta.isFull?'':'container']},[_c('router-view')],1),(!_vm.$route.meta.isProductCase)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }